import React from 'react';
import {Box, Container, Stack, styled, Typography, useMediaQuery, useTheme} from '@mui/material';
import FeedbackCarousel from '../components/FeedbackCarousel.js';
import {imagekitStaticURL} from '../util/util.js';
import Banner from '../components/Banner.js';
import {withTitle} from '../title.js';
import withMainContainer from '../components/WithMainContainer.js';
import Polaroid from '../components/Polaroid.js';
import WhatsAppButton from '../components/WhatsAppButton.js';
import StackWithArrow from '../components/StackWithArrow.js';

const WHATSAPP_MESSAGE = `היי סימונה, אשמח לקבל פרטים על פגישת ייעוץ אישית 🌸`;

const ServiceDetailsBox = styled(props=>{
    let {className, children} = props;
    return <Stack className={className} padding={3} gap={2}>
      {children}
    </Stack>;
})`
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.7);
`;

const Meeting = ()=>{
    let theme = useTheme();    
    let sm = useMediaQuery(theme.breakpoints.down('sm'));
    return <Stack direction="column">
      <Banner image={imagekitStaticURL('tarot-banner.png')}
        placeholderColor="#34152b" padding={4} backgroundPosition="25%">
        <Typography variant="h4" textAlign="center">
          פגישת ייעוץ אישית
        </Typography>
        <Typography textAlign="center">
          מה היית מעדיפה?<br/>
          לשמוע מה הולך לקרות בעתיד שלך<br/>
          או לדעת איך בדיוק להשיג את החיים שאת חולמת עליהם?
        </Typography>
      </Banner>
      <Container maxWidth="lg">
        <Stack direction="column" gap={3} marginTop={4} alignItems="center">
          <Typography textAlign="center">
            מרגישה שמשהו יושב לך על הלב?<br/>
            יש שאלה שחוזרת שוב ושוב, תחום שמרגיש תקוע, או פשוט תחושת בלבול או חוסר כיוון?
          </Typography>
          <Typography textAlign="center">
            בפגישה איתי נוכל להסתכל יחד לעומק, להבין מה באמת קורה מתחת לפני השטח ומה אפשר לעשות מכאן כדי לשנות את המצב.
          </Typography>
          <Typography textAlign="center">
            בעזרת ליווי צמוד וכלים רוחניים שאני מתאימה בדיוק בשבילך, נוכל לראות את התמונה הגדולה, לזהות חסמים ובליינד ספוטס - ויחד נבנה גשר בין המקום שאת נמצאת בו עכשיו למקום שבו את רוצה להיות - בקריירה, בזוגיות ובכל תחום אחר.
          </Typography>
          <Stack justifyContent="center" alignItems="center" marginTop={3} marginBottom={3}>
            <Box component="img" maxWidth="200px"
              src={imagekitStaticURL`moon-divider.png`} sx={{objectFit: 'contain'}}/>
          </Stack>
        </Stack>
      </Container>
      <StackWithArrow backgroundColor={theme.palette.primary.light} marginTop={3} arrowIndex={1}>
        <Container maxWidth="lg" sx={{zIndex: 2}}>
          <Stack direction={sm ? 'column' : 'row'}
            alignItems="center"
            gap={3} paddingTop={4} paddingBottom={4}>
            <Stack direction="column" gap={3}>
              <Polaroid width="250px" height="250px" src={imagekitStaticURL`profile-pic-1.jpg`}/>
            </Stack>
            <Stack direction="column" gap={3} alignItems="center">
              <Typography textAlign={sm ? 'center' : null}>
                היי, אני סימונה צ’רי ואני כאן כדי לעזור לך למצוא את התשובות בתוכך ולברוא את המציאות שתמיד רצית בעזרת כלים שונים כמו טארוט, נומרולוגיה, אסטרולוגיה, תקשור ופירוש חלומות.
              </Typography>
              <Typography textAlign={sm ? 'center' : null}>
                עד כה, עזרתי למאות א.נשים לפתור בעיות עמוקות ולמצוא את הדרך שלהם בחיים, בין אם בליווי אישי, במעגלי נשים או בסדנאות שאני מעבירה.
              </Typography>
            </Stack>
          </Stack>
        </Container>
      </StackWithArrow>
      <Banner noOverlay image={imagekitStaticURL`flowers-bg-1.png`} maxWidth="md">
        <Stack direction="column" gap={3} marginTop={7}>
          <Typography variant="h4" textAlign="center">
            סוגי המפגשים
          </Typography>
          <ServiceDetailsBox>
            <Typography variant="h5" textAlign="center">
              "אני רק שאלה"
            </Typography>
            <Typography fontWeight="bold" textAlign="center">
              שיחת ייעוץ טלפונית של חצי שעה או שעה
            </Typography>
            <Typography textAlign="center">
              מתאימה אם יש לך שאלה ספציפית שמעסיקה אותך או התלבטות בוערת - כשצריך תשובה ברורה כאן ועכשיו.
            </Typography>
          </ServiceDetailsBox>
          <ServiceDetailsBox>
            <Typography variant="h5" textAlign="center">
              "אני רוצה להסתכל על התמונה הגדולה"
            </Typography>
            <Typography fontWeight="bold" textAlign="center">
              פגישת עומק בזום
            </Typography>
            <Typography textAlign="center">
              מפת דרכים אישית בכל תחום כמו זוגיות, קריירה, לימודים, יחסים או כל נושא אחר שמעסיק אותך ותרצי להבין <strong>ולשפר.</strong><br/>
              המפה מאפשרת לנו לראות מה קורה השנה, מהם האתגרים וההזדמנויות, מה באמת חוסם אותך ומה בדיוק אפשר לעשות כדי לשנות את המצב ולקדם שינוי אמיתי, חיובי ומודע.
            </Typography>
          </ServiceDetailsBox>
        </Stack>
      </Banner>
      <Stack marginTop={3}>
        <Container maxWidth="lg">
          <Stack direction="column" gap={3}
            justifyContent="center" alignItems="center">
            <Stack direction="column" gap={3} justifyContent="center"
              alignItems="center" marginTop={4} marginBottom={4}>
              <Typography variant="h4" textAlign="center">
                מוכנה להתחיל ליצור את השינוי בחייך?
              </Typography>
              <WhatsAppButton text="לתיאום ייעוץ בוואצאפ" message={WHATSAPP_MESSAGE} variant="contained"/>
              <Stack alignItems="center" gap={2} marginTop={2}>
                <Box component="img" src={imagekitStaticURL`spread-cards.png`}
                  width="200px" sx={{objectFit: 'contain'}}/>
              </Stack>
            </Stack>
            {/* <Typography variant="h5" textAlign="center">
              פגישה אחת יכולה לפתוח לך עולם!
            </Typography>
            <Typography textAlign="center">
              ולפעמים, אחרי שמתבהרת התמונה - הלב מבקש ליווי שיחזיק אותך בדרך, כי הבהירות היא רק ההתחלה, והשינוי האמיתי קורה כשצועדים איתה קדימה.<br/><br/>
              למי שתרצה - אני מציעה גם תהליך אישי ומתמשך:<br/>
              כזה שמעמיק, מדייק, ומביא לתוצאות בשטח.<br/>
              זו אפשרות נוספת, אם תרגישי שזה מדויק לך.
            </Typography>
            <WhatsAppButton text="לתיאום ייעוץ בוואצאפ"/> */}
          </Stack>
        </Container>
      </Stack>
      <Stack width="100%" sx={{backgroundColor: theme.palette.primary.dark}} marginTop={4}>
        <Container maxWidth="lg">
          <Typography color={theme.palette.primary.contrastText} align="center" variant="h3" marginTop={4}>
            מה לקוחות מספרות על הפגישות איתי
          </Typography>
          <FeedbackCarousel tags="tarot-feedback"/>
          <Stack justifyContent="center" alignItems="center" marginBottom={4}>
            <WhatsAppButton text="לתיאום ייעוץ בוואצאפ" variant="contained"  message={WHATSAPP_MESSAGE}/>
          </Stack>
        </Container>
      </Stack>
    </Stack>
};

export default withMainContainer(withTitle(`סימונה צ'רי - ייעוץ אישי ומדויק בעזרת טארוט, נומרולוגיה ואסטרולוגיה`, Meeting), {headerMargin: 0});
